var updateGlobalListeners = function updateGlobalListeners(change, listeners, func, options) {
  if (change !== 'add' && change !== 'remove') {
    return new Error('Valid change type only (add or remove)');
  }

  var eventMod = change === 'add' ? 'addEventListener' : 'removeEventListener';
  var listenerArray = Array.isArray(listeners) ? listeners : [listeners];
  listenerArray.forEach(function (listener) {
    return document[eventMod](listener, func, options);
  });
  return true;
};

export default updateGlobalListeners;